import { __assign, __rest, __spreadArrays } from "tslib";
import React from "react";
import ReactMarkdown from "react-markdown"; // @ts-ignore

import HtmlToReact from "html-to-react"; // @ts-ignore

import htmlParser from "react-markdown/plugins/html-parser";
import * as Components from "./renderers";

function parser(_a) {
  var _b = _a.parsers,
      parsers = _b === void 0 ? [] : _b,
      others = __rest(_a, ["parsers"]);

  var isValidNode = function isValidNode(node) {
    return node.type !== "script";
  };

  var processNodeDefinitions = new HtmlToReact.ProcessNodeDefinitions(React);
  return htmlParser({
    isValidNode: isValidNode,
    processingInstructions: __spreadArrays(parsers.map(function (p) {
      return p(__assign({
        parsers: parsers
      }, others));
    }), [{
      // Anything else
      shouldProcessNode: function shouldProcessNode(node) {
        return true;
      },
      processNode: processNodeDefinitions.processDefaultNode
    }])
  });
}

export var MarkdownComponent = function MarkdownComponent(_a) {
  var source = _a.source,
      _b = _a.escapeHtml,
      escapeHtml = _b === void 0 ? false : _b,
      _c = _a.skipHtml,
      skipHtml = _c === void 0 ? false : _c,
      _d = _a.customRenderers,
      customRenderers = _d === void 0 ? {} : _d,
      _e = _a.parsers,
      parsers = _e === void 0 ? [] : _e,
      _f = _a.highlightTheme,
      highlightTheme = _f === void 0 ? null : _f,
      _g = _a.headingPrefix,
      headingPrefix = _g === void 0 ? "" : _g,
      _h = _a.copyButton,
      copyButton = _h === void 0 ? null : _h;
  if (!source) return null;
  var headings = new Set();
  var defaultRenderers = {
    root: Components.Root,
    text: Components.Text,
    break: Components.Break,
    paragraph: Components.Paragraph,
    emphasis: Components.Emphasis,
    strong: Components.Strong,
    thematicBreak: Components.ThematicBreak,
    blockquote: Components.Blockquote,
    delete: Components.Delete,
    link: Components.Link,
    linkReference: Components.Link,
    image: Components.Image,
    imageReference: Components.Image,
    table: Components.Table,
    tableHead: Components.TableHead,
    tableBody: Components.TableBody,
    tableRow: Components.TableRow,
    tableCell: Components.TableCell,
    list: Components.List,
    listItem: Components.ListItem,
    definition: Components.Definition,
    heading: function heading(props) {
      return React.createElement(Components.Heading, __assign({}, props, {
        headingPrefix: headingPrefix,
        headings: headings
      }));
    },
    inlineCode: Components.InlineCode,
    code: function code(props) {
      return React.createElement(Components.Code, __assign({}, props, {
        highlightTheme: highlightTheme,
        copyButton: copyButton
      }));
    },
    html: Components.HTML,
    virtualHtml: Components.VirtualHTML,
    parsedHtml: Components.ParsedHTML
  };

  var renderers = __assign(__assign({}, defaultRenderers), customRenderers); // temporary solution for passing custom props to heading components


  renderers.heading = function (props) {
    return customRenderers.heading ? React.createElement(customRenderers.heading, __assign({}, props, {
      headingPrefix: headingPrefix,
      headings: headings
    })) : React.createElement(Components.Heading, __assign({}, props, {
      headingPrefix: headingPrefix,
      headings: headings
    }));
  };

  var astPlugins = [parser({
    parsers: parsers,
    customRenderers: customRenderers,
    highlightTheme: highlightTheme,
    headingPrefix: headingPrefix,
    copyButton: copyButton
  })];
  return React.createElement(ReactMarkdown, {
    source: source,
    escapeHtml: escapeHtml,
    skipHtml: skipHtml,
    renderers: renderers,
    astPlugins: astPlugins
  });
};